import React from 'react'

import { Stack } from 'components/layout/primitives'
import { SpaceProp } from 'components/layout/primitives/utils'
import { FieldProps } from '../types'
import { overrideProps } from 'react-nanny'
import { Label } from 'ui/inputs/fields/Label'
import { ErrorMessage } from 'ui/inputs/fields/ErrorMessage'

export const FieldWrapper: React.FC<React.PropsWithChildren<FieldProps & SpaceProp>> = ({
	label,
	htmlFor,
	tooltipText,
	error,
	children,
	space = 'smaller'
}) => {
	if (!React.isValidElement(children)) return <p>Invalid Input</p>
	return (
		<Stack space={space}>
			<Label htmlFor={htmlFor} label={label} tooltipText={tooltipText} />
			{overrideProps(children, () => ({ id: name }))}
			{error && <ErrorMessage error={error} />}
		</Stack>
	)
}
